import { render } from "./compliance_rules.html?vue&type=template&id=6da6c172&scoped=true&external"
import script from "./compliance_rules.js?vue&type=script&lang=js&external"
export * from "./compliance_rules.js?vue&type=script&lang=js&external"

import "./ComplianceRules.vue?vue&type=style&index=0&id=6da6c172&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da6c172"]])

export default __exports__